/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.


list

*/
import React, {useState, useEffect } from "react";

import { Card, CardHeader, CardBody, Row, Col, Input } from "reactstrap";

import dataTypes from "views/diary/dataType.js";
import Modal from 'react-modal';

// add new codes
import { useHistory } from 'react-router-dom';

// end

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding:'0.25rem',
    width:'85%',
    borderRadius:'15px',
    fontWeight:'bold'
  },
};

function AphorismsEdit1() {

  let session = JSON.parse(window.sessionStorage.getItem('sessions'));
  if(!session){
    window.location = '/';
  }

  const history = useHistory();
  const newFlag = window.sessionStorage.getItem('newFlag');
  // const category = JSON.parse(window.sessionStorage.getItem('s_category')) || null;
  const p_aphorism = JSON.parse(window.sessionStorage.getItem('p_aphorism')) || null;
  // const pId = window.sessionStorage.getItem('pId');
  const aphorism = JSON.parse(window.sessionStorage.getItem('s_aphorism')) || null;
  // const [content, setContent] = useState(aphorism && newFlag == 0 ? aphorism.content : '' );
  const [modalIsOpen, setIsOpen]    = useState(false);
  // console.log(aphorism);
  const [word, setWord] = useState(aphorism && newFlag == 0 ? (aphorism.word ? aphorism.word : '') : '' );
  const [name, setName] = useState(aphorism && newFlag == 0 ? (aphorism.name ? aphorism.name : '') : '' );
  const [man, setMan] = useState(aphorism && newFlag == 0 ? (aphorism.man ? aphorism.man : '') : '' );

  // const onChangeContent = (e) => {
  //   setContent(e.target.value);
  // }
  const onChangeData = (e, f) => {
    if(f == 1){
      setWord(e.target.value);
    }else if(f == 2){
      setName(e.target.value);
    }else{
      setMan(e.target.value);
    }
  }
  const onSave = (e) => {
    if(newFlag == 1){
      axios.get(URL_API+"AddNewAph", {
        params: {
          user_id : session['id'], 
          p_id : p_aphorism.id,
          // content : content,
          word:word,
          name:name,
          man:man
        }
      })
      .then(function (response) {
        history.push('../coach/apList');
      }); 
    }else{
      // console.log(word);
      axios.get(URL_API+"saveAph", {
        params: {
          user_id : session['id'],
          id : aphorism.id,
          p_id : p_aphorism.id,
          // content : content,
          word:word,
          name:name,
          man:man
        }
      })
      .then(function (response) {    
        history.push('../coach/apList');
      }); 
    }
  }
  const onRemoveSelectedItem = (event) => {
    setIsOpen(true);
  }

  const onRemoveSelItem = (event) => {
    axios.get(URL_API+"delAphItem", {
      params: {
        id:aphorism.id,
        user: session['id'],
      }
    })
    .then(function (response) {
      history.push('../coach/apList');
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    );  
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const onUpPage = (e) => {    
    history.push('../coach/apList');
  }
  // useEffect(() => {

  // }, []);

  return (
    <>      
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal">
        <div className="row col-12 px-0 mx-0 py-2 justify-content-center align-items-center border-bottom">
          削除
        </div>
        <div className="row col-12 px-0 mx-0 py-4 justify-content-center align-items-center border-bottom">
          本当に削除しますか？
        </div>
        <div className="col-12 px-0 mx-0 d-flex justify-content-between align-items-center">
          <span className="col-6 py-2 px-0 d-flex justify-content-center align-items-center" onClick={(event) => setIsOpen(false)}>キャンセル</span>
          <span className="col-6 py-2 px-0 d-flex justify-content-center align-items-center border-left" onClick={(event) => onRemoveSelItem(event)}>削除</span>
        </div>
      </Modal>
      <div className="content px-0 pb-0">
        <div className="titleDiv">
          <Card className="mb-0">
            <CardBody className="seldate p-1 d-flex" id='seldate' style={{color:'white'}}>
              <div className="d-flex col-12 px-2">
                <div className="col-3 col-lg-2 d-flex align-items-center justify-content-start px-0">
                  <span className="p-1" style={{fontSize:'14px'}} onClick={(e) => onUpPage(e)}>キャンセル</span>
                </div>
                <div className="col-6 col-lg-8 text-center px-0 d-flex align-items-center justify-content-center head_title">
                    格言
                </div>
                <div className="col-3 col-lg-2 d-flex align-items-center justify-content-end px-0">
                  <span className="p-1" style={{fontSize:'14px'}} onClick={(e) => onSave(e)}>完了</span>
                </div>
              </div>
            </CardBody>
            <CardBody className="px-2 diary_list">
              <div className="col-12 d-flex px-0 py-0">
                <div className="col-12 px-0">
                  <label>言葉</label>
                  <input type="text" className="col-12 form-control" value={word} onChange={(e) => onChangeData(e, 1)}/>
                </div>
              </div>
              <div className="col-12 d-flex px-0 py-0">
                <div className="col-12 px-0">
                  <label>名前</label>
                  <input type="text" className="col-12 form-control" value={name} onChange={(e) => onChangeData(e, 2)}/>
                </div>
              </div>
              <div className="col-12 d-flex px-0 py-0">
                <div className="col-12 px-0">
                  <label>人物の説明</label>
                  <textarea className="col-12 form-control" value={man} onChange={(e) => onChangeData(e, 3)}  style={{height:'calc(100vh - 395px)', maxHeight:'unset'}}>{man}
                  </textarea>
                </div>
              </div>
              {/*<div className="col-12 d-flex px-0 py-0">
                              <div className="col-12 px-0">
                                <label>に分けて作成。</label>
                                <textarea className="col-12 form-control p-2" type="text" value={content} id="title" name="title" onChange={onChangeContent} placeholder="" style={{height:'calc(100vh - 395px)', maxHeight:'unset'}}>{content}</textarea>
                              </div>
                            </div>*/}
              <div className="col-12 px-0">
                { newFlag == 0 && (
                  <span className="col-12 px-0 text-center py-3 btn btn-simple mb-0" onClick={(event) => onRemoveSelectedItem(event)}>削除</span>)
                }
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default AphorismsEdit1;
